import React from "react";
import ContentLoader from "react-content-loader";

const ProductPlaceHolder = (props) => {
  return (
    <ContentLoader
      height={350}
      width={245}
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="2" y="2" rx="0" ry="0" width="240" height="197" />
      <rect x="15" y="220" rx="0" ry="0" width="140" height="25" />
      <rect x="15" y="254" rx="0" ry="0" width="65" height="15" />
    </ContentLoader>
  );
};

export default ProductPlaceHolder;
